import { all } from "redux-saga/effects";
import doctorSignUp from "./doctorSignUp.saga";
import getAllLanguages from "./languages.saga";
import getAllSpecialities from "./speciality.saga";

function* rootSaga() {
  yield all([doctorSignUp(), getAllLanguages(), getAllSpecialities()]);
}

export default rootSaga;
